import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-close-icon',
  templateUrl: './close-icon.component.html',
  styleUrls: ['./close-icon.component.scss']
})
export class CloseIconComponent {

  @Output() closeIcon = new EventEmitter();

  closePopup() {

    this.closeIcon.emit();
  }
}
